import { Component, output } from '@angular/core';
import { Button } from 'excellence-ui';
import { NgIcon } from '@ng-icons/core';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-energy-interface-list-empty',
  imports: [Button, NgIcon, TranslocoPipe],
  templateUrl: './energy-interface-list-empty.html',
})
export class EnergyInterfaceListEmpty {
  clickCreate = output<void>();
}
